import axios from 'axios'

let cachedSettings = null
let pending = null

export async function fetchInviteSettings(force = false) {
  if (!force && cachedSettings) {
    return cachedSettings
  }
  if (!force && pending) {
    return pending
  }
  pending = axios
    .get('/api/v1/invite/settings')
    .then((res) => {
      const data = res.data?.data || {}
      cachedSettings = {
        mode: data.mode || 'optional',
        enabled: !!data.enabled,
        required: !!data.required
      }
      return cachedSettings
    })
    .catch(() => {
      cachedSettings = { mode: 'optional', enabled: true, required: false }
      return cachedSettings
    })
    .finally(() => {
      pending = null
    })
  return pending
}

export function clearInviteSettingsCache() {
  cachedSettings = null
}

export async function fetchInviteBindStatus() {
  const res = await axios.get('/api/v1/invite/bind/status')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '无法获取邀请码状态')
  }
  return res.data.data || {}
}

export async function bindInviteCode(code) {
  const res = await axios.post('/api/v1/invite/code/bind', { code: (code || '').trim() })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '绑定失败')
  }
  return res.data
}

export const INVITE_GATE_WHITELIST = [
  '/invite/required',
  '/login',
  '/register',
  '/wechatcallback',
  '/officialcallback',
  '/security/captcha'
]

export function isInviteGateWhitelisted(path) {
  if (path.startsWith('/admin')) {
    return true
  }
  return INVITE_GATE_WHITELIST.some((p) => path === p || path.startsWith(`${p}?`))
}

/** 登录成功后若必须补填邀请码，返回 /invite/required 路由对象 */
export async function resolvePostLoginRoute(defaultPath = '/') {
  const href = typeof defaultPath === 'string' && defaultPath.startsWith('/') ? defaultPath : '/'
  try {
    const settings = await fetchInviteSettings()
    if (!settings.required) {
      return href
    }
    const status = await fetchInviteBindStatus()
    if (status.needsBinding) {
      return { path: '/invite/required', query: { href } }
    }
  } catch {
    // ignore
  }
  return href
}
